export const pixelatedTechOrganizationSchema = {
    '@type': ['Organization', 'LocalBusiness'],
    '@id': 'https://www.pixelated.tech/#organization',
    name: 'Pixelated Technologies',
    url: 'https://www.pixelated.tech',
    telephone: '+1-973-710-8008',
    priceRange: '$$',
    address: {
        streetAddress: '10 Jade Circle',
        addressLocality: 'Denville',
        addressRegion: 'NJ',
        postalCode: '07834',
        addressCountry: 'US',
    },
    image: '/images/pix/pix-bg-512.gif',
};
